module.exports = __webpack_public_path__ + "pc/img/ico-26ver-benfit01.50f84ee3.png";